import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/admin/header/PageHeader";
import TagEditForm from "@/components/admin/tag/TagEditForm";
import { routes } from "@/configs/router.config/routes";
import { useTags } from "@/hooks/useTags";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { TagService } from "@/services/tag/tag.service";
import { showError, showSuccess } from "@/utils/notification";

const TagCreatePage: React.FC = () => {
  const { t } = useTranslation("admin");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { mutate } = useTags(sessionCurrentWorkspaceId);

  const submit = async (name: string, description: string) => {
    try {
      setIsLoading(true);
      await TagService.createTag({
        workspaceId: sessionCurrentWorkspaceId,
        name,
        description,
      });
      await mutate();
      setIsLoading(false);
      showSuccess(t("tag.message.createSuccess"));
      navigate(routes.tagList(sessionCurrentWorkspaceId));
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      showError(t("tag.message.createError"));
    }
  };

  return (
    <>
      <PageHeader hasBack title={t("tag.createTitle")} />

      <TagEditForm submit={submit} isLoading={isLoading} />
    </>
  );
};

export default TagCreatePage;
